import Header from "@/sections/Header";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import About from "@/sections/About";
import Tokenomics from "@/sections/Tokenomics";
import Roadmap from "@/sections/Roadmap";
import HowToBuy from "@/sections/HowToBuy";
import Faq from "@/sections/Faq";
import Community from "@/sections/Community";
import AlienId from "@/sections/AlienId";
import ReferralWidget from "@/sections/ReferralWidget";
import Footer from "@/sections/Footer";
import RoomStartBanner from "@/components/RoomStartBanner";
import TicketExpiringBanner from "@/components/TicketExpiringBanner";
import { FEATURES } from "@/lib/features";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="relative min-h-screen bg-background text-foreground">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Tokenomics />
        <Roadmap />
        <HowToBuy />
        <AlienId />
        <ReferralWidget />
        <Faq />
        <Community />
      </main>
      <Footer />
      {FEATURES.rooms && (
        <>
          <RoomStartBanner />
          <TicketExpiringBanner />
        </>
      )}
    </div>
  );
}
